import { Box, FormControlSizes, IconButton, IconName, useFavoriteSecurities } from '@talos/kyoko';
import { getIsPriceGridFavoritesOnly, setIsPriceGridFavoritesOnly } from './favorites';
import type { PriceGridFilterState } from './types';

interface PriceGridFavoriteFilterButtonProps {
  filterState: PriceGridFilterState;
  onFilterStateChanged: (filterState: PriceGridFilterState) => void;
}

export function PriceGridFavoriteFilterButton({
  filterState,
  onFilterStateChanged,
}: PriceGridFavoriteFilterButtonProps) {
  const { favoriteSecurities } = useFavoriteSecurities();
  const showFavoritesOnly = getIsPriceGridFavoritesOnly(filterState);

  return (
    <Box display="flex" alignItems="center" alignSelf="center">
      <IconButton
        ghost
        size={FormControlSizes.Small}
        icon={showFavoritesOnly ? IconName.StarSolid : IconName.Star}
        color={showFavoritesOnly ? 'yellow.lighten' : 'gray.080'}
        data-testid="price-grid-favorites-filter"
        onClick={() => {
          onFilterStateChanged(setIsPriceGridFavoritesOnly(filterState, !showFavoritesOnly, favoriteSecurities));
        }}
      />
    </Box>
  );
}
